<!-- Header.vue -->
<template>
	<div>
		<div id="header" class="header-wrapper">
			<div class="kuang">
				<div class="header">
					<div class="left">
						<div class="logo">
							<a href="/"><img src="@/images/logo3.png" /></a>
						</div>
						<div class="menu-wrapper">
							<ul class="menu">
								<li v-for="(item, index) in translatedMenuItems" :key="index" class="menu-item">
								        <router-link :to="item.link">{{ item.label }}</router-link>
								</li>
							</ul>
						</div>
					</div>
					<div class="right">
					<div class="wangluo" :class="{ 'language-click-itme': isClassAdded }">
						<div class="item language_control" @click="languageControl">
							<i class="fas fa-globe"></i>
							<div class="text" v-if="$i18n.locale == 'en'">EN</div>
							<div class="text" v-else>CN</div>
							<i class="fas fa-caret-down"></i>
						</div>
						<ul class="language-menu">
							<li class="menu-item">
								<a @click="switchLanguage('zh-CN')">
									<div class="icon">
										<img src="@/images/icon-3.png"/>
									</div>
									<div class="text">简体中文</div>
								</a>
							</li>
							<li class="menu-item">
								<a @click="switchLanguage('en')">
									<div class="icon">
										<img src="@/images/icon-4.png"/>
									</div>
									<div class="text">English</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
				</div>
			</div>
		</div>   
	
		<div class="mobile-menu">
			<div class="mobile_box">
				<div class="logo">
					<a href="/"><img src="@/images/logo.png" /></a>
				</div>
				<div class="menu-toggle" @click="toggleMenu">
				  <i class="fas fa-bars"></i>
				</div>
			</div>
			
			<div class="clear"></div>
			
		    <div class="menu-items" ref="MenuOpen" :class="{ 'menu-itme': isMenuOpen }">
				<div class="menuBox">
					<div class="menu-toggle" @click="toggleMenu">
					  <i class="fas fa-times"></i>
					</div>
					<ul class="menu_list">
					  
					  <li v-for="(item, index) in translatedMenuItems" :key="index" class="menu-item" @click="handleMenuItemClick(item.link)">
							  <router-link :to="item.link">{{ item.label }}</router-link>
					  </li>
					  
					  <li :class="{ 'language-click-itme': isClassAdded }">
						  <div @click="languageControl" class="earth">
							  <div class="left_text">
								  <i class="fas fa-globe"></i>
								  <div class="text"><a href="#">{{ $i18n.locale }}</a></div>
							  </div>
							  <i class="fas fa-caret-down icon-arrow"></i>
						  </div>
						  
						  <ul class="mobie-language-menu" >
							  <li class="menu-item">
							  	<a @click="mBswitchLanguage('zh-CN')">
							  		<div class="icon">
							  			<img src="@/images/icon-3.png"/>
							  		</div>
							  		<div class="text">简体中文</div>
							  	</a>
							  </li>
							  <li class="menu-item">
							  	<a @click="mBswitchLanguage('en')">
							  		<div class="icon">
							  			<img src="@/images/icon-4.png"/>
							  		</div>
							  		<div class="text">English</div>
							  	</a>
							  </li>
						  </ul>
					  </li>
					</ul>
				</div>
				
		    </div>
		  </div>

	</div>
</template>

<script>
	export default {
	  name: 'Header',
	  data() {
		  return {
			isMenuOpen: false,
			isClassAdded: false,
			menuItems: [
				{ label: 'message.home', link: '/' },
				{ label: 'message.game', link: '/game' },
				{ label: 'message.service', link: '/service' },
				{ label: 'message.join', link: '/join' },
				{ label: 'message.contact', link: '/contact' },
			  ],
		  };
		},
	  computed: {
		translatedMenuItems() {
		  return this.menuItems.map((item) => ({
			...item,
			label: this.$t(item.label),
		  }));
		},
	  },
	  methods: {
		toggleMenu() {
			this.isMenuOpen = !this.isMenuOpen;
		},
		mBswitchLanguage(locale) {
			// 切换语言
			this.$i18n.locale = locale;
			this.toggleMenu();
		},
		handleMenuItemClick(link){
			this.$router.push(link);
			this.toggleMenu();
		},
		languageControl(){
			this.isClassAdded = !this.isClassAdded;
		},
	    switchLanguage(locale) {
	      // 切换语言
	      this.$i18n.locale = locale;
		  this.languageControl();
	    },
	  }
	};
</script>

